import React from "react";
import { FluentProvider } from "@fluentui/react-components";
import { Router } from "./Router";
import { lightTheme } from "./theme";
export const App = () => {
  // Render the Router component only if authenticated or not in the test environment
  return (
    <FluentProvider theme={lightTheme}>
      <Router />
    </FluentProvider>
  );
};
